export const DEFAULT_SLIDER_MENU_PADDING = 60;
export const GRIP_BAR_HEIGHT = 40;
